import { useMutation } from '@tanstack/react-query';
import { changeStatusInBatches } from '../lib/bulk';
import type { StatusAction } from '../lib/suggestion-types';
import { useInvalidateMapping } from './use-invalidate-mapping';

export type StatusVariables = { action: StatusAction; listingIds: string[] };

/** Moves listings to Skipped, or back to To review. */
export function useSkipRestore() {
  const invalidate = useInvalidateMapping();

  return useMutation({
    mutationFn: ({ action, listingIds }: StatusVariables) =>
      changeStatusInBatches(action, listingIds),
    onSettled: invalidate,
  });
}
